import { useFilterQuery } from 'framework-listing-lib/hooks/useListingLibFilters';
import useSearchTokens from '../hooks/useSearchTokens';
import { View } from 'foundations-components/components/View';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
function escapeSpecialCharacters(str) {
  return str.replace(/(\.|\+|\*|\?|\^|\$|\(|\)|\[|\]|\{|\}|\|)/gi, (_, p1) => `\\${p1}`);
}
const HighlightText = ({
  value
}) => {
  const filterQuery = useFilterQuery();
  const searchTokens = useSearchTokens();
  if (!filterQuery || searchTokens.length === 0 || !value) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: value
    });
  }
  const searchRegex = new RegExp(`(${[escapeSpecialCharacters(filterQuery), ...searchTokens.map(escapeSpecialCharacters)].join('|')})`, 'gi');
  // Split on search term and wrap each match with the highlighted style
  const parts = value.split(searchRegex).filter(part => part.length > 0);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: parts.map((part, i) => /*#__PURE__*/_jsx(View, {
      as: "span",
      backgroundColor: part.match(searchRegex) ? 'fill-accent-yellow-subtle' : undefined,
      children: part
    }, i))
  });
};
export default HighlightText;